import { NgModule } from '@angular/core';
import { HttpModule } from '../http/http.module';

@NgModule({
  imports: [HttpModule],
  declarations: [],
})
export class AuthRepositoryModule {}
